import {Component, Input} from '@angular/core';
import {SimpleXploreItemDTO, XploreItemDTO} from "../../../shared/object/xplorer-be-parsed-classes";
import {environment} from "../../../../environments/environment";
import {ImageManager} from "../../../shared/image-manager";


@Component({
    selector: 'app-preview-item-card',
    templateUrl: './preview-item-card.component.html',
    styleUrls: ['./preview-item-card.component.css'],
    imports: []
})
export class PreviewItemCardComponent {

  @Input() xploreItem: SimpleXploreItemDTO;

  getImage() {
    if (!this.xploreItem) {
      console.warn("⚠ getImage(): `xploreItem` è undefined o null.");
      return ImageManager.getPlaceholderImage();
    }

    if (!this.xploreItem.multiMediaUrls || this.xploreItem.multiMediaUrls.length === 0) {
      console.warn("⚠ getImage(): Nessuna immagine trovata in multiMedia.");
      return ImageManager.getPlaceholderImage();
    }

    return environment.IMAGES_URL + this.xploreItem.multiMediaUrls[0];
  }

}
